import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import {
  persistedUserReducer,
  loginReducer,
  userRepository,
  createAccountReducer,
  otpReducer,
  chatRepository,
  chatReducer,
  tierRepository,
  profileReducer,
  changePasswordReducer,
  menuReducer,
  addonRepository,
  avatarRepository,
  modelProfileReducers,
  galleryReducer,
  mediaRepository,
  chatSubsReducer,
  paymentRepository,
} from "../di/di";

export const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    menu: menuReducer,
    login: loginReducer,
    createAccount: createAccountReducer,
    otp: otpReducer,
    chat: chatReducer,
    profile: profileReducer,
    changePassword: changePasswordReducer,
    modelProfile: modelProfileReducers,
    gallery: galleryReducer,
    chatSubs: chatSubsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          userRepository,
          chatRepository,
          tierRepository,
          addonRepository,
          avatarRepository,
          mediaRepository,
          paymentRepository,
        },
      },
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
